<template>
  <div>
    <div id="entire_bus_component">
      <div class="title_container">
        <svg
          id="search-eye-line"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
        >
          <path
            id="Path_51"
            data-name="Path 51"
            d="M0,0H24V24H0Z"
            fill="none"
          />

          <path
            id="Path_52"
            data-name="Path 52"
            d="M18.031,16.617,22.314,20.9,20.9,22.314l-4.282-4.283a9,9,0,1,1,1.414-1.414Zm-2.006-.742a7,7,0,1,0-.15.15l.15-.15Zm-3.847-8.7a2,2,0,1,0,2.646,2.646,4,4,0,1,1-2.646-2.646Z"
            fill="#1d2329"
          />
        </svg>

        <h2>Set routes & Schedule Journeys</h2>
      </div>

      <Toast />

      <Toast position="bottom-right" group="br" />

      <form
        action="#"
        method="post"
        class="form d-flex flex-wrap justify-content"
      >
        <div class="form-division-1 mx-3 col-lg-5">
          <div class="form-group">
            <select
              class="form-control"
              @change="SourceDestinations()"
              v-model="routeSource"
              name="source"
              id="source"
              required
            >
              <option
                v-if="
                  routes.length !=0 && routes!=null && routes!=undefined
                "
                selected
                disabled
                value
                >Select source</option
              >
              <option v-else selected disabled value
                >There are no free buses</option
              >
              <option
                v-for="route in routes"
                :key="route.id"
                :value="route.source"
                >{{ route.source }}</option
              >
            </select>
          </div>

          <div class="form-group">
            <select
              class="form-control"
              v-model="destination"
              name="destination"
              id="destination"
              required
            >
              <option selected disabled value>Select destination</option>

              <option
                v-for="destination in customDestins"
                :key="destination"
                :value="destination"
                >{{ destination }}</option
              >
            </select>
          </div>
        </div>

        <div class="form-division-2 mx-3  col-lg-6">
          <div class="d-flex flex-wrap col-12 bus-and-btn p-0">
            <div class="form-group col-6 p-0">
              <input
                type="date"
                class="form-control"
                v-model="departDate"
                :min="new Date().toISOString().split('T')[0]"
                :max="maxDate"
                data-date-format="DD MMMM YYYY"
                name="date"
                id="date"
                placeholder="Select date and time"
              />
            </div>

            <div class="form-group col-5  p-0">
              <input
                type="time"
                class="form-control"
                v-model="departTime"
                name="time"
                id="time"
                placeholder="Select date and time"
              />
            </div>
          </div>

          <div class="d-flex flex-wrap col-12 bus-and-btn p-0">
            <div class="form-group col-6 p-0">
              <select
                class="form-control col-12"
                name="bus"
                id="bus"
                v-model="busId"
                required
              >
                <option v-if="buses.length != 0" selected disabled value=""
                  >Select bus</option
                >

                <option v-else selected disabled value=""
                  >There are no free buses</option
                >

                <option v-for="bus in buses" :key="bus.id" :value="bus.id">{{
                  bus.busplatenumber
                }}</option>
              </select>
            </div>

            <button
              type="submit"
              class="btn btn-primary col-5 publishBtn"
              @click.prevent="publishRoute()"
            >
              Publish route

              <div
                v-if="publishing"
                class="spinner-border spinner-border-sm ml-3 text-white"
                role="status"
              ></div>
            </button>
          </div>
        </div>
      </form>

      <div class="title_container">
        <svg
          id="pulse-fill"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
        >
          <path
            id="Path_31"
            data-name="Path 31"
            d="M0,0H24V24H0Z"
            fill="none"
          />

          <path
            id="Path_32"
            data-name="Path 32"
            d="M9,7.539l6,14L18.659,13H23V11H17.341L15,16.461l-6-14L5.341,11H1v2H6.659Z"
            fill="#1d2329"
          />
        </svg>

        <h2>Set Routes</h2>
      </div>

      <ul class="nav sub-nav-li">
        <li class="nav-item">
          <router-link to="/shaloi/todaySchedules" class="sub-nav-link"
            >Today</router-link
          >
        </li>

        <li class="nav-item sub-nav-li">
          <router-link to="/shaloi/futureSchedules" class="sub-nav-link"
            >Others</router-link
          >
        </li>
      </ul>

      <hr />

      <div class="set_routes_display">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import axios from "axios";
import formatDateMixin from "../../../mixins/formatDateMixins";
let token = localStorage.getItem("jwt");
const headers = { Authorization: `Bearer ${token}` };
export default {
  data() {
    return {
      selectedProducts3: null,
      filters2: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        busplatenumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
        source: { value: null, matchMode: FilterMatchMode.CONTAINS },
        destination: { value: null, matchMode: FilterMatchMode.CONTAINS },
        date: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      departTime: null,
      departDate: null,
      buses: [],
      routes: [],
      routeId: "",
      routeSource: "",
      LoadingData: true,
      publishing: false,
      busId: "",
      destination: "",
      customDestins: [],
      setRoutes: [],
      AddedRoutesArray: [],
    };
  },
  mounted() {
    this.returnBusesWithOutSchedule();
    this.routesNotScheduled();
  },
  mixins: [formatDateMixin],
  computed: {
    formattedDate() {
      return this.formatDate(this.date);
    },
    maxDate() {
      let dtToday = new Date();
      let month = dtToday.getMonth() + 1; // getMonth() is zero-based
      let day = dtToday.getDate() + 2;
      let year = dtToday.getFullYear();
      if (month < 10) month = "0" + month.toString();
      if (day < 10) day = "0" + day.toString();

      return year + "-" + month + "-" + day;
    },
  },
  methods: {
    routesNotScheduled() {
        axios
          .get(
            `https://bookinga.herokuapp.com/api/v1/busSchedule/routes/free`,
            {
              headers,
            }
          )
          .then((res) => {
            if (res.data.message != "all routes are in booking mode") {
              this.routes = res.data.message;
            }
          })
          .catch((res) => {
              console.log(res);
            this.LoadingData = false;
          });
    },
    returnBusesWithOutSchedule() {
        axios
          .get(`https://bookinga.herokuapp.com/api/v1/busSchedule/buses/free`, {
            headers,
          })

          .then((res) => {
            if (res.data.message != "all buses are in booking mode") {
              this.buses = res.data.message;
            }
          })
          .catch((res) => {
            this.LoadingData = false;
          })      
    },
    publishRoute() {
      this.publishing = true;
      for (let i = 0; i < this.routes.length; i++) {
        if (
          this.routes[i].source == this.routeSource &&
          this.routes[i].destination == this.destination
        )
          this.routeId = this.routes[i].id;
      }
      axios
        .post(
          "https://bookinga.herokuapp.com/api/v1/busSchedule",
          {
            routeId: this.routeId,
            startTime: this.departTime,
            date: this.departDate,
            busId: this.busId,
          },
          { headers }
        )
        .then((res) => {
          if (res.data.success == true) {
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: "Route published successfully",
              group: "br",
              life: 5000,
            });
            this.publishing = false;
            // this.showTable = true;
            this.AddedRoutesArray.push({
              source: this.routeSource,
              destination: this.destination,
              date: this.departDate,
              time: this.departTime,
              busplatenumber: this.busId,
            });
            (this.routeSource = ""),
              (this.destination = ""),
              (this.departTime = ""),
              (this.departDate = ""),
              (this.busId = "");
            return;
          } else {
            this.publishing = false;
            return this.$toast.add({
              severity: "warn",
              summary: "An error occured",
              detail: res.data.message,
              life: 10000,
            });
          }
        });
    },
    SourceDestinations() {
      let route = this.routeSource;
      this.customDestins = [];
      for (let i = 0; i < this.routes.length; i++) {
        if (this.routes[i].source == route) {
          this.customDestins.push(this.routes[i].destination);
        }
      }
    },
  },
//   watch: {
//     AddedRoutesArray: {
//       handler(val, oldVal) {
//         this.returnBusesWithOutSchedule();
//         this.routesNotScheduled();
//       },
//       deep: true,
//     },
//   },
};
</script>

<style lang="scss" scoped>
@import "../../companyAdmin/tables_mobile.scss";
.set-routes-container {
  width: 97.8%;
  margin: 0 auto;
}

.title_container {
  width: 100%;
  height: fit-content;
  margin-bottom: 10px;
  display: flex;
  position: relative;
  h2 {
    font-size: 0.95em;
    font-family: satoshi, $poppins !important;
    position: relative;
    font-weight: 500;
    left: 2%;
  }
  svg {
    position: relative;
    left: 1%;
  }
}

h5 {
  color: $gradientDark;
  margin-top: 0.5%;
  margin-left: 1%;
  margin-bottom: 1%;
  font-size: 0.9em;
}

.sub-nav-link {
  margin: 0.625rem !important;
  /* background: grey !important; */
  padding: 0.375rem 0.9375rem;
  border-radius: 5px 5px 0px 0px;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  border-bottom: none !important;
  color: gray;
  font-size: 13px;
}

a.active {
  background: #487fff !important;
  color: white !important;
  border: 1px solid #487fff;
}

hr {
  margin-top: 0.25rem !important;
  border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.form {
  background-color: #f5f7fb;
  width: 97%;
  justify-content: center;
}

.set_routes_display {
  margin: 0em auto;
  width: 97%;
  justify-content: center;
}

.row_filter_one {
  width: 100%;
  border: none !important;
}

.form-division-1,
.form-division-2 {
  padding-top: 1.75rem !important;
}

.publishBtn {
  min-width: fit-content;
  height: 45px;
  font-size: 0.8rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bus-and-btn {
  justify-content: space-between;
}

.modal-body {
  padding: 10px 30px;
}

.modal-body p {
  font-size: 14px !important;
}

.modal-close-btn {
  width: fit-content;
  padding: 3px 40px;
  margin: 15px;
}

.modal-body .modal-heading {
  font-size: 18px;
  color: blue;
  text-align: center;
  margin: 10px 0;
}

.modal {
  margin: auto !important;
}

.form-check-label {
  font-size: 13px;
}

.form-checks {
  margin: 5px 0;
}

.p-calendar > .p-inputtext {
  font-size: 0.8em !important;
  padding: 1em !important;
  border: 1px solid white !important;
}

.form-check-input {
  margin-top: 2.5px;
}

.form-group {
  margin-bottom: 1.4em !important;
}

.form-control {
  margin-bottom: 0 !important;
}

.form-check {
  margin: 10px 0;
}

#entire_bus_component {
  width: 100%;
  height: 100vh;
  margin-bottom: 10px;
}
</style>
